import _ from 'lodash';
/**
 * Transforms an array into a array of objects where every element is transformed into an object
 * ['value1', 'value2'] => [{key: 'value1', value: 'value1'}, {key: 'value2', value: 'value2'}]
 * Optionally value can be passes to a transformer function to change their shape
 * @param arr
 * @param {function} transformer
 * @returns {Array}
 */
export default function mirrorKeys(arr, transformer = _.identity) {
  return _.map(arr, key => ({ value: key, label: transformer(key) }));
}
